export const frontendURI = '/cat/document_category/';
export const backendURI = `/api${frontendURI}`;
